import React, { useState } from "react";
import { API } from "@/lib/api";

// Renders a member's avatar by user_id; falls back to a colored initial if none.
export default function ChatAvatar({ userId, name, size = 28 }) {
  const [failed, setFailed] = useState(false);
  const initial = (name || "?").trim().charAt(0).toUpperCase();
  const dim = { width: size, height: size };
  if (!userId || failed) {
    return (
      <div style={dim} className="rounded-full bg-[#5B7CFA]/25 border border-[#5B7CFA]/40 flex items-center justify-center text-[#AFC0FF] text-xs font-bold shrink-0">
        {initial}
      </div>
    );
  }
  return (
    <img
      src={`${API}/users/${userId}/avatar`}
      alt={name}
      style={dim}
      onError={() => setFailed(true)}
      className="rounded-full object-cover border border-white/10 shrink-0"
    />
  );
}
